import { NgModule } from '@angular/core';
import { NoSupportIePopupLibModule } from './no-support-ie-popup/no-support-ie-popup-lib.module';

@NgModule({
  declarations: [],
  imports: [NoSupportIePopupLibModule],
  exports: []
})
export class MaxUiDesignModule {}
